import {
  ADD_FROM_FACEBOOK_REQUESTED,
  ADD_FROM_FACEBOOK_FAILURE,
  ADD_FROM_FACEBOOK_SUCCESS,
} from 'actiontypes/contacts';
import ContactService from 'services/ContactService';
import fetchContacts from './fetchContacts';

const service = new ContactService();

/** ----------------------------------------------------------------------------
 * Add Friends from Facebook
 -----------------------------------------------------------------------------*/
export default function addFromFacebook() {
  return (dispatch) => {
    dispatch(addFromFacebookRequested());
    return service.addFacebookContacts()
      .then(({ data }) => {
        if (data.isSuccess || !('isSuccess' in data)) {
          dispatch(addFromFacebookSuccess(data));
          dispatch(fetchContacts());
          return data;
        }
        // If the API has failed to respect REST semantics and sent back a 200 with
        // an error message, then treat the response as an error
        return Promise.reject({ response: { data: { message: data.message } } });
      })
      .catch((error) => {
        dispatch(addFromFacebookFailure(error));
      });
  };
}

export const addFromFacebookRequested = () => ({ type: ADD_FROM_FACEBOOK_REQUESTED, isAdding: true });

export const addFromFacebookSuccess = data => ({
  type: ADD_FROM_FACEBOOK_SUCCESS,
  payload: {
    message: data.message,
  },
});

export const addFromFacebookFailure = error => ({
  type: ADD_FROM_FACEBOOK_FAILURE,
  payload: {
    error: true,
    message: error.response && error.response.data.message,
    status: error.response && error.response.status,
  },
});
